<template>
    <v-layout row wrap class="ypo-events-filter-options__type-ahead">
        <v-flex>
            <v-text-field
                class="ypo-events-filter-options__type-ahead--input"                
                :data-qe-id="`ypo-event-filter_${typeAheadKey.filterKey}_type-ahead_input-field`"
                @keyup="getTypeAheadResult(searchText)"                    
                :placeholder="setHostTypeAheadLabel(appliedHostFilters, typeAheadKey)"
                v-model="searchText"                             
                clearable>                    
            </v-text-field>
            <v-layout column
                      class="ypo-events-filter-options__type-ahead--result inner-scrollbar"
                      v-if="searchText && searchText.length > 2">
             <status-overlay
                        :action="typeAheadAction"
                        content-height="60px"></status-overlay>
                <v-flex xs4
                        class="ypo-events-filter-options__type-ahead--result--item"
                        v-if="searchResult && searchResult.length > 0"
                        v-for="(searchItem, index) in searchResult"
                        :key="index" pa-2>
                    <label class="check-container ypo_blue_color">
                        <span :data-qe-id="`ypo-events-filter_${typeAheadKey.filterKey}_type-ahead_result_${index}_label`">
                            {{searchItem.label}}
                        </span>
                        <input type="checkbox"
                               :value="searchItem"
                               :data-qe-id="`ypo-events-filter_${typeAheadKey.filterKey}_type-ahead_result_${index}_checkbox`" 
                               @change="applySelectedFilter(searchItem, typeAheadKey.filterKey)"                                
                               v-model="localSelectedFilters">
                        <span class="checkmark"></span>
                    </label>
                </v-flex>
                <v-flex xs4 pa-2
                        v-if="searchResult && searchResult.length === 0"
                        :data-qe-id="`ypo-events-filter_${typeAheadKey.filterKey}_type-ahead_no-result_statement`"
                        class="ypo-events-filter-options__type-ahead_no-result">
                  {{`No events to display for that ${typeAheadKey.filterKey.toLowerCase() === 'chapters' ? 'chapter' : 'network'}`}}
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
import {
    ypoEventConstant, 
    setHostTypeAheadLabel,
 } from "@/components/YpoEvents/ypoEvents.constant";
import { mapActions, mapState } from "vuex";
import { storeAction } from "@/store/storeActions.constant";
import StatusOverlay from "@/components/StatusOverlay/StatusOverlay";

export default {
    name: 'YpoEventTypeAhead',
    components: { StatusOverlay },
    props: {
        typeAheadKey: {
            type: Object,
            required: true,
        },
        additionalFilterToQuery: {
            type: Object,
            default: null,
        },
        handleSelectedFilter: {
            type: Function,
            required: true,
        },        
        appliedHostFilters: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
            return {
                searchText: '',
                searchResult: null,
                timeoutForTypeAhead: null,
                localSelectedFilters: [],
            };
        },
        methods: {
        ...mapActions({
                getYpoEventsTypeAheadSearch: `ypoEvents/${storeAction.getYpoEventsTypeAheadSearch}`,
            }),
            getTypeAheadResult() {
                const { searchText, additionalFilterToQuery, typeAheadKey } = this;
                if (searchText && searchText.length < 3) {
                    this.searchResult = null;
                }
                if (searchText && searchText.length > 2) {
                    const typeAheadData = {
                        searchText,  
                        selectedTypeAhead: typeAheadKey,
                        selectedFilters: {                           
                            [this.typeAheadKey.ribbonGroupName]: [],
                        },
                        additionalFilterToQuery,     
                    };
                    this.getYpoEventsTypeAheadSearch(typeAheadData)
                        .then((resp) => {
                            if (resp && resp.data && resp.data.result) {
                                const filteredResult = []; 
                                resp.data.result.forEach((re) => {                                    
                                    filteredResult.push({
                                      ...re,
                                      isTypeAheadHostFilter: true,
                                    });
                                });                               
                                this.searchResult = [...filteredResult];
                            }
                        })
                        .catch(() => {
                            this.searchResult = null;
                        });
                }
            }, 
            setHostTypeAheadLabel, 
            applySelectedFilter(filterItem, parentKey) {  
                    const newFilter = {
                        ...filterItem,
                        ribbonGroupName: ypoEventConstant.constant.keys.hostFilter.charAt(0).toUpperCase() + ypoEventConstant.constant.keys.hostFilter.slice(1),
                    };
                this.handleSelectedFilter(newFilter, parentKey);
            }, 
        },
        computed: {
            ...mapState('actionState', ['actions']),
          typeAheadAction() {
            return this.actions[storeAction.getYpoEventsTypeAheadSearch];
          },
        },        
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-events-filter-options {
  background-color: $ypo-extra-light-gray;

  &__type-ahead {
    @extend %ypo-secondary-checkbox;;
    margin-top: -7px;

    &--input {
      background-color: $white;
      max-width: 600px;
      margin-top: 0px !important;
      padding-top: 0px !important;
    }

    &--result {
      background-color: $white;
      border: 1px solid $ypo-tile-border;
      padding: 10px;
      border-top: none;
      width: 100%;
      margin-left: 1%;
      max-width: 550px;
      min-height: 60px !important;
      position: relative;
      max-height: 230px !important;
      overflow: auto;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

      &--item {
        font-size: 12px;
        color: black;
      }
    }

    &-previous {
      background-color: $white;
      border: 1px solid $ypo-tile-border;
      padding: 20px 40px 15px;
    }

    &_no-result {
      color: $ypo-border-gray;
      font-size: 12px !important;
    }
  }
}
</style>

<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-events-filter-options {
  &__type-ahead {

    .v-input.ypo-events-filter-options__type-ahead--input input::placeholder {
      color: #777777;
      font-family: "Noto Sans";
      font-size: 12px;
      letter-spacing: 0;
      line-height: 17px;
      padding-left: 6px;
      padding-bottom: 0px;
    }

    .v-input.ypo-events-filter-options__type-ahead--input input {
      padding: 0px;
    }


    .v-text-field--box input, .v-text-field--outline input {
      margin-top: 0 !important;
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }

    &--result {
      .v-input--selection-controls.v-input .v-label {
        &:hover {
          font-weight: 600 !important;
          text-decoration: none !important;
        }
      }
    }

    .check-container {
      white-space: normal !important;
      font-size: 12px !important;
      color: $ypo-border-gray !important;
      padding-top: 2px !important;
      margin-bottom: -10px !important;

      &:hover {
        text-decoration: underline !important;;
      }
    }
  }
}

.host-type-ahead {
  .ypo-events-filter-options__typeAhead {

    .v-text-field {
      padding-top: 0;
      margin-top: 5px;
    }

    &--input {
      .v-input__slot {
        border: none !important;
        border-radius: 0 !important;
        border-bottom: 1px solid $ypo-gray !important;
        min-height: 35px !important;
      }

    }

  }
}
</style>
